import { render } from "./GlButton.vue?vue&type=template&id=494b35de&scoped=true"
import script from "./GlButton.vue?vue&type=script&lang=js"
export * from "./GlButton.vue?vue&type=script&lang=js"

import "./GlButton.vue?vue&type=style&index=0&id=494b35de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-494b35de"

export default script